module.exports = __webpack_public_path__ + "img/mtt_1.2.326e2c4d.png";